// import React from 'react';
// import { UserPlus, User, Mail, Phone, Building2, Hash, Clock, X, Loader2 } from 'lucide-react';
// import InputField from '../../Organization/Manager_Dashboard/utils/InputField';
// import TimeInputField from '../../Organization/Manager_Dashboard/utils/TimeInputField';
// import TimeZoneSelect from '../../Organization/Manager_Dashboard/utils/TimeZoneSelect';
// import ViewTimeZone from '../../Organization/Manager_Dashboard/utils/ViewTimeZone';

// const CreateUserModal = ({
//   isOpen,
//   onClose,
//   onSubmit,
//   formData,
//   onInputChange,
//   managers,
//   userRole,
//   isCreating,
//   timeZones
// }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
//       <div className="bg-richblue-950 border border-blue-700/50 rounded-2xl w-full sm:max-w-2xl max-h-[92vh] overflow-y-auto sm:mb-0 mb-[30px]" onClick={(e) => e.stopPropagation()}>
//         <div className="sticky top-0 flex items-center justify-between p-5 border-b bg-richblue-950 border-blue-800/40">
//           <h2 className="flex items-center gap-2 text-xl font-bold text-white">
//             <UserPlus className="w-5 h-5 text-blue-200" /> Create New User
//           </h2>
//           <button onClick={onClose} className="p-2 transition-colors rounded-lg hover:bg-blue-600/20">
//             <X className="w-5 h-5 text-blue-400" />
//           </button>
//         </div>

//         <form onSubmit={onSubmit} className="p-5 space-y-5">
//           <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
//             <InputField
//               icon={User}
//               name="user_name"
//               label="Full Name *"
//               placeholder="John Doe"
//               value={formData.user_name}
//               onChange={onInputChange}
//               disabled={isCreating}
//             />
//             <InputField
//               icon={Mail}
//               name="user_email"
//               label="Email"
//               type="email"
//               placeholder="john@company.com"
//               value={formData.user_email}
//               onChange={onInputChange}
//               disabled={isCreating}
//             />
//             <InputField
//               icon={Phone}
//               name="user_phone"
//               label="Phone"
//               placeholder="9876543210"
//               value={formData.user_phone}
//               onChange={onInputChange}
//               disabled={isCreating}
//             />
//             <InputField
//               icon={Building2}
//               name="user_department"
//               label="Department"
//               placeholder="CSE"
//               value={formData.user_department}
//               onChange={onInputChange}
//               disabled={isCreating}
//             />
//             <InputField
//               icon={Hash}
//               name="user_roll"
//               label="ID *"
//               placeholder="21BTCS0207"
//               value={formData.user_roll}
//               onChange={onInputChange}
//               disabled={isCreating}
//             />
            
//             {userRole !== 'Manager' && (
//               <div>
//                 <label className="block mb-2 text-sm font-medium text-blue-300">
//                   <User className='inline w-4 h-4 mr-1 text-blue-400' />
//                   Manager <span className='text-lg text-red-400/70'>*</span>
//                 </label>
//                 <select
//                   name="manager_Id"
//                   value={formData.manager_Id}
//                   onChange={onInputChange}
//                   required
//                   className="w-full px-4 py-2 text-white border rounded-lg bg-richblue-900 border-blue-800/60 focus:outline-none focus:ring-2 focus:ring-blue-700"
//                 >
//                   <option value="">Select Manager</option>
//                   {managers.map(manager => (
//                     <option key={manager._id} value={manager._id}>
//                       {manager.manager_name} ({manager.manager_email})
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}

//             <TimeInputField
//               icon={Clock}
//               name="shift_start"
//               label="Shift Start *"
//               value={formData.shift_start}
//               onChange={onInputChange}
//               disabled={isCreating}
//             />
//             <TimeInputField
//               icon={Clock}
//               name="shift_end"
//               label="Shift End *"
//               value={formData.shift_end}
//               onChange={onInputChange}
//               disabled={isCreating}
//             />
//             <TimeZoneSelect
//               formData={formData}
//               handleChange={onInputChange}
//               timeZones={timeZones}
//               loading={isCreating}
//             />
//             <ViewTimeZone
//               formData={formData}
//               handleChange={onInputChange}
//               timeZones={timeZones}
//               loading={isCreating}
//             />
//           </div>

//           <div className="flex gap-3 pt-2">
//             <button
//               type="button"
//               onClick={onClose}
//               className="flex-1 px-4 py-2.5 rounded-lg border border-blue-800/60 text-blue-300 hover:bg-blue-800/20 transition-colors text-sm font-medium"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={isCreating}
//               className="flex-1 px-4 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-500 disabled:opacity-50 transition-colors text-white text-sm font-semibold flex items-center justify-center gap-2"
//             >
//               {isCreating ? (
//                 <>
//                   <Loader2 className="w-4 h-4 animate-spin" /> Creating...
//                 </>
//               ) : (
//                 <>
//                   <UserPlus className="w-4 h-4" /> Create User
//                 </>
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CreateUserModal;

import React from 'react';
import { UserPlus, User, Mail, Phone, Building2, Hash, Clock, X, Loader2 } from 'lucide-react';
import InputField from '../../Organization/Manager_Dashboard/utils/InputField';
import TimeInputField from '../../Organization/Manager_Dashboard/utils/TimeInputField';
import TimeZoneSelect from '../../Organization/Manager_Dashboard/utils/TimeZoneSelect';
import ViewTimeZone from '../../Organization/Manager_Dashboard/utils/ViewTimeZone';

const CreateUserModal = ({
  isOpen,
  onClose,
  onSubmit,
  formData,
  onInputChange,
  managers,
  userRole,
  isCreating,
  timeZones,
  theme
}) => {
  if (!isOpen) return null;

  const isDark = theme === 'dark';

  // Theme-aware classes
  const bgModal = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgHeader = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgSelect = isDark ? 'bg-richblue-900' : 'bg-gray-50';
  
  const borderColor = isDark ? 'border-blue-700/50' : 'border-gray-300';
  const borderLight = isDark ? 'border-blue-800/40' : 'border-gray-200';
  const borderInput = isDark ? 'border-blue-800/60' : 'border-gray-300';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-300' : 'text-gray-700';
  //const textMuted = isDark ? 'text-blue-400' : 'text-gray-500';
  //const textBlue = isDark ? 'text-blue-400' : 'text-blue-600';
  
  const hoverBg = isDark ? 'hover:bg-blue-600/20' : 'hover:bg-gray-100';
  const buttonCancel = isDark 
    ? 'border-blue-800/60 text-blue-300 hover:bg-blue-800/20'
    : 'border-gray-300 text-gray-700 hover:bg-gray-100';
  
  const buttonSubmit = isDark
    ? 'bg-blue-600 hover:bg-blue-500'
    : 'bg-blue-500 hover:bg-blue-600';

  return (
    <div className={`fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 ${isDark ? 'bg-black/50' : 'bg-gray-500/30'} backdrop-blur-sm`} onClick={onClose}>
      <div className={`${bgModal} border ${borderColor} rounded-2xl w-full sm:max-w-2xl max-h-[92vh] overflow-y-auto sm:mb-0 mb-[30px] transition-colors duration-300`} onClick={(e) => e.stopPropagation()}>
        <div className={`sticky top-0 flex items-center justify-between p-5 border-b ${bgHeader} ${borderLight}`}>
          <h2 className={`flex items-center gap-2 text-xl font-bold ${textPrimary}`}>
            <UserPlus className="w-5 h-5 text-blue-200" /> Create New User
          </h2>
          <button onClick={onClose} className={`p-2 transition-colors rounded-lg ${hoverBg}`}>
            <X className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-gray-500'}`} />
          </button>
        </div>

        <form onSubmit={onSubmit} className="p-5 space-y-5">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <InputField
              icon={User}
              name="user_name"
              label="Full Name *"
              placeholder="John Doe"
              value={formData.user_name}
              onChange={onInputChange}
              disabled={isCreating}
              theme={theme}
            />
            <InputField
              icon={Mail}
              name="user_email"
              label="Email"
              type="email"
              placeholder="john@company.com"
              value={formData.user_email}
              onChange={onInputChange}
              disabled={isCreating}
              theme={theme}
            />
            <InputField
              icon={Phone}
              name="user_phone"
              label="Phone"
              placeholder="9876543210"
              value={formData.user_phone}
              onChange={onInputChange}
              disabled={isCreating}
              theme={theme}
            />
            <InputField
              icon={Building2}
              name="user_department"
              label="Department"
              placeholder="CSE"
              value={formData.user_department}
              onChange={onInputChange}
              disabled={isCreating}
              theme={theme}
            />
            <InputField
              icon={Hash}
              name="user_roll"
              label="ID *"
              placeholder="21BTCS0207"
              value={formData.user_roll}
              onChange={onInputChange}
              disabled={isCreating}
              theme={theme}
            />
            
            {userRole !== 'Manager' && (
              <div>
                <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>
                  <User className={`inline w-4 h-4 mr-1 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                  Manager <span className='text-lg text-red-400/70'>*</span>
                </label>
                <select
                  name="manager_Id"
                  value={formData.manager_Id}
                  onChange={onInputChange}
                  required
                  className={`w-full px-4 py-2 ${textPrimary} ${bgSelect} border ${borderInput} rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
                >
                  <option value="">Select Manager</option>
                  {managers.map(manager => (
                    <option key={manager._id} value={manager._id} className={isDark ? 'bg-richblue-950' : 'bg-white'}>
                      {manager.manager_name} ({manager.manager_email})
                    </option>
                  ))}
                </select>
              </div>
            )}

            <TimeInputField
              icon={Clock}
              name="shift_start"
              label="Shift Start *"
              value={formData.shift_start}
              onChange={onInputChange}
              disabled={isCreating}
              theme={theme}
            />
            <TimeInputField
              icon={Clock}
              name="shift_end"
              label="Shift End *"
              value={formData.shift_end}
              onChange={onInputChange}
              disabled={isCreating}
              theme={theme}
            />
            <TimeZoneSelect
              formData={formData}
              handleChange={onInputChange}
              timeZones={timeZones}
              loading={isCreating}
              theme={theme}
            />
            <ViewTimeZone
              formData={formData}
              handleChange={onInputChange}
              timeZones={timeZones}
              loading={isCreating}
              theme={theme}
            />
          </div>

          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className={`flex-1 px-4 py-2.5 rounded-lg border ${buttonCancel} transition-colors text-sm font-medium`}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isCreating}
              className={`flex-1 px-4 py-2.5 rounded-lg ${buttonSubmit} disabled:opacity-50 transition-colors text-white text-sm font-semibold flex items-center justify-center gap-2`}
            >
              {isCreating ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" /> Creating...
                </>
              ) : (
                <>
                  <UserPlus className="w-4 h-4" /> Create User
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateUserModal;
